import type { User } from 'oidc-client-ts';
import type { NavigateFunction } from 'react-router';
import type { PatientDataInput } from '../graphql/generated/graphql';
import { stripTypename } from '../utils/helpers';
import { hasFrontDeskRole, hasSomeRole, Role } from '../utils/user';
import { useAppStore } from './store/useAppStore';
import { useCurrentContextStore } from './store/useCurrentContextStore';

export const mayReorder = (user: User | null | undefined) =>
  hasSomeRole([Role.ROLE_LR_MEDCOM, Role.ROLE_LR_USER, Role.ROLE_LR_LAB_ADMIN, Role.ROLE_LR_FRONT_DESK], user);

// Opens the parameter selection of a Nachforderung to the sent request; without a `doctor` the current Zuweiser stays
export const startReorder = (
  request: { id: string; doctor?: { id: string }; patientData: PatientDataInput; comment: string },
  navigate: NavigateFunction,
  { user, replace = false }: { user: User | null | undefined; replace?: boolean }
) => {
  const { setRequestIdForReorder, setPatientData, setComment } = useAppStore.getState();
  const patientData = stripTypename(request.patientData);
  if (patientData.insuredPerson) {
    patientData.insuredPerson = stripTypename(patientData.insuredPerson);
  }
  // front desk works on the catalogs of the primary Zuweiser, like the backend validates them
  if (request.doctor && !hasFrontDeskRole(user)) {
    useCurrentContextStore.getState().setCurrentDoctorId(request.doctor.id);
  }
  setRequestIdForReorder(request.id);
  setPatientData(patientData);
  setComment(request.comment);
  navigate('/anforderung/parameterauswahl', { replace });
};
